import { render, staticRenderFns } from "./Telefonos.vue?vue&type=template&id=f4b6128e&scoped=true"
import script from "./Telefonos.vue?vue&type=script&lang=js"
export * from "./Telefonos.vue?vue&type=script&lang=js"
import style0 from "./Telefonos.vue?vue&type=style&index=0&id=f4b6128e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b6128e",
  null
  
)

export default component.exports